import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getPatientDemographicsOptionsSelector } from '../selectors/patientDemographicsOptions.selector'
import { setEmailDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors/getPatientDemographics.selector'
import { OptionsConstants } from '../store/options.constants'
import { IPatientDemographicsOptionsState } from '../store/options.types'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'

export function* setEmailType() {
  const patientDemographicsOptions: IPatientDemographicsOptionsState = yield select(
    getPatientDemographicsOptionsSelector
  )
  const { emailType, emailDetail } = patientDemographicsOptions
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { emailDetails } = patientDemographics
  const selectedEmail = emailDetails.filter((email) => email.key === emailDetail?.key)
  if (selectedEmail && selectedEmail.length) {
    selectedEmail[0].type = emailType
    yield put(setEmailDetails(emailDetails))
  }
}

export function* setEmailTypeSaga() {
  yield takeLatest([OptionsConstants.SET_EMAIL_TYPE], setEmailType)
}
